export function gaTrack(name, category, label = "", value) {
    gtag("event", name, {
        category,
        label,
        value,
    });
}
